/**
 * @generated SignedSource<<110431deb6777fe84ce2979524dfa57e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkstreamUpdateMutation$variables = {
  name: string;
  workstreamId: number;
};
export type WorkstreamUpdateMutation$data = {
  readonly updateWorkstream: {
    readonly workstream: {
      readonly id: number;
      readonly name: string;
    } | null | undefined;
  };
};
export type WorkstreamUpdateMutation = {
  response: WorkstreamUpdateMutation$data;
  variables: WorkstreamUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workstreamId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "workstreamId"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "concreteType": "UpdateWorkstreamResult",
    "kind": "LinkedField",
    "name": "updateWorkstream",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "workstreams",
        "kind": "LinkedField",
        "name": "workstream",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkstreamUpdateMutation",
    "selections": (v2/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkstreamUpdateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "254fc3fc9b55189a63ddbb80820d657c",
    "id": null,
    "metadata": {},
    "name": "WorkstreamUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation WorkstreamUpdateMutation(\n  $workstreamId: Int!\n  $name: String!\n) {\n  updateWorkstream(id: $workstreamId, name: $name) {\n    workstream {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f7580890e7533f1ec2a7f83957bc887d";

export default node;
